<template lang="pug">
div(class="container")
  div(class="card")
    header(class="card-header")
      p(class="card-header-title") Add order
    div(class="card-content")
      div(v-if="loading" class="loading")
        p Loading . . .

      b-error(v-if="error" :error="error" class="error")
    footer(class="card-footer")
</template>

<script>
const bError = require('@nx-t/vue-components/vue2/bError').default;

export default {
  components: {
    bError,
  },
  data() {
    return {
      loading: false,
      error: null,
    };
  },
  created() {
    this.merchantToken = this.$route.params.merchantToken;
    this.nr = this.$route.params.nr;
    this.id = this.$route.params.id;

    this.fetchData();
  },
  methods: {
    async fetchData() {
      this.error = null;
      this.loading = true;

      try {
        const orderAddParams = new URLSearchParams({
          merchantToken: this.merchantToken,
          nr: this.nr,
          id: this.id,
        });

        const response = await fetch(`/order/add?${orderAddParams.toString()}`);
        if (!response.ok) {
          const errorData = await response.json();
          throw errorData || { message: 'Unknown Error', status: response.status };
        }

        const data = await response.json();
        if (data.nr.toString() !== this.nr || data.id !== this.id) {
          this.error = 'unmatched response';
          return;
        }

        if (!data.success) {
          this.error = data.errorMessage;
        } else if (data.existingOrderUrl) {
          window.location.href = data.existingOrderUrl;
        } else {
          const params = new URLSearchParams({
            orgId: data.data.orgId,
            type: 'planC1',
            order: encodeURIComponent(JSON.stringify(data.data.order)),
            assets: encodeURIComponent(JSON.stringify(data.data.assets)),
            payments: encodeURIComponent(JSON.stringify(data.data.payments)),
          });

          const myUrlWithParams = `${data.meinUrl}/prefill?${params}`;
          window.location.href = myUrlWithParams;
        }
      } catch (e) {
        this.error = e?.toString() || 'Unknown Error';
      } finally {
        this.loading = false;
      }
    },
  },
};

</script>
